module.exports = __webpack_public_path__ + "static/img/09.c408237a.png";